<div class="flex items-center justify-between">
	<h2 class="text-xs font-bold text-gray-900">قدرت خرید</h2>
	<ui-button
		variant="mute"
		iconOnly
		extraButtonClasses="!size-6 !rounded-md"
		data-cy="wallet-mini-visibility"
		[label]="visibilityLabel()"
		[ariaPressed]="amountsHidden()"
		(clicked)="toggleVisibility()">
		<ui-icon width="16" height="16" aria-hidden="true" [iconName]="visibilityIcon()" />
	</ui-button>
</div>

<!-- Label first, value second: the RTL reading order puts each name on the right. -->
<dl class="flex flex-col">
	@for (row of rows(); track row.dataCy; let first = $first) {
		<div
			class="flex items-center justify-between gap-2 py-1.5"
			[class.border-t]="!first"
			[class.border-stroke-050]="!first">
			<dt class="text-xs font-medium text-gray-900">{{ row.label }}</dt>
			<dd
				class="flex items-center gap-1 text-3.25 font-medium"
				[class.text-yellow-600]="row.emphasised"
				[class.text-gray-900]="!row.emphasised">
				@if (amountsHidden()) {
					<span class="tracking-widest" [attr.data-cy]="row.dataCy">{{ maskedValue }}</span>
				} @else {
					<ui-number
						format="1.0-0"
						dir="ltr"
						class="tabular-nums"
						[attr.data-cy]="row.dataCy"
						[value]="row.value" />
				}
				<span [class.text-gray-500]="!row.emphasised">ریالءء</span>
			</dd>
		</div>
	}
</dl>

<ui-button
	variant="green"
	model="outline"
	size="md"
	class="w-full"
	extraButtonClasses="h-8 w-full"
	data-cy="wallet-mini-deposit"
	(clicked)="onDepositRequested()">
	واریز وجه
	<ui-icon rightIcon width="18" height="18" iconName="plus" />
</ui-button>
